export default "__VITE_ASSET__1f6b5554__"